import { LogLevel } from "../types/index.js";

export type LogContext = Record<string, unknown>;

export interface LoggerAdapter {
	isDev: boolean;
	captureMessage: (message: string, options: { level: LogLevel; extra?: LogContext }) => void;
	captureException: (error: unknown, options: { extra: LogContext }) => void;
}

export interface Logger {
	info: (message: string, context?: LogContext) => void;
	warn: (message: string, context?: LogContext) => void;
	error: (message: string, error?: unknown, context?: LogContext) => void;
}

export function createLogger(adapter: LoggerAdapter): Logger {
	return {
		info: (message, context) => {
			if (adapter.isDev) {
				if (context) {
					console.info(message, context);
					return;
				}
				console.info(message);
				return;
			}
			adapter.captureMessage(message, { level: LogLevel.INFO, extra: context });
		},
		warn: (message, context) => {
			if (adapter.isDev) {
				if (context) {
					console.warn(message, context);
					return;
				}
				console.warn(message);
				return;
			}
			adapter.captureMessage(message, { level: LogLevel.WARNING, extra: context });
		},
		error: (message, error, context) => {
			if (adapter.isDev) {
				if (context) {
					console.error(message, error, context);
					return;
				}
				if (error !== undefined) {
					console.error(message, error);
					return;
				}
				console.error(message);
				return;
			}
			adapter.captureException(error ?? new Error(message), { extra: { message, ...context } });
		},
	};
}
